import _ from 'lodash';
import { useContext, useRef, useState } from "react";
import { RentTrackerContext } from '../../pages/tenants/rent-tracker';
import { MonthLine } from './monthLine';
import NumberHelpers from '../../app/number-helpers';

export const RentTrackerContainer = () => {

    const numberHelpers = new NumberHelpers();
    const { rentData, setRentData, saveMonthLine } = useContext(RentTrackerContext);
    const childRefs = useRef([]); // Initialize an array of refs
    
    const [includeSettled, setIncludeSettled] = useState(false);

    const paymentAllocation = monthLine => {
        return _.sumBy(monthLine.paymentAllocations, pa => {
            const value = pa.value;
            // Handle cases where value is a string ending with '.' or is an incomplete number
            if (typeof value === 'string') {
                if (value.endsWith('.') || value === '') {
                    return parseFloat(`${value}0`);
                }
                return parseFloat(value) || 0;
            }
            return value || 0;
        });
    };

    const handlePaymentAllocation = (value, rowIndex) => {

        const cleanValue = value.trim();
        const numericValue = cleanValue === '' || cleanValue.endsWith('.')
            ? `${cleanValue}0000001`
            : parseFloat(cleanValue);

        const newRentData = [...rentData];

        newRentData[rowIndex].paymentAllocation = numberHelpers.safeParseFloat(numericValue, 2);
        newRentData[rowIndex].paymentAllocationStr = cleanValue;
        setRentData(newRentData);
    };

    const handleLocalSaveMonthLine = (monthLine, index) => {

        saveMonthLine(monthLine);

        if (childRefs.current[index].canSave()) {
            childRefs.current[index].reset(monthLine);
        }
    };

    return (

        <div className="row">
            <div className="col-xs-2 col-md-12 table-responsive">
                <h4>Recent and Upcoming Payments</h4>
                <div className="form-check form-switch">
                    <label className="form-check-label" htmlFor="allDay">Exclude Settled</label>
                    <input className="form-check-input" type="checkbox" id="allDay" checked={includeSettled} onChange={e => setIncludeSettled(e.target.checked)} />
                </div>
                <table className="mt-10px table table-bordered align-middle table-hover table-dark">
                    <thead className="thead-dark">
                        <tr>
                            <th className="align-middle text-center" nowrap="true">#</th>
                            <th className="align-middle text-center">Month</th>
                            <th className="align-middle text-center">Tenant</th>
                            <th className="align-middle text-center">Rent Due</th>
                            <th className="align-middle text-center">Sum of Debits/ Credits</th>
                            <th className="align-middle text-center">Total Due</th>
                            <th className="align-middle text-center">Allocation</th>
                            <th className="align-middle text-center">Sum Of Payments Received</th>
                            <th className="align-middle text-center">Month Shortfall/ Overage</th>
                            <th className="align-middle text-center">Overall Debit/ Credit</th>
                            <th className="align-middle text-center">Payment Settled</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rentData.map(r => {
                            const pa = paymentAllocation(r);
                            return {
                                ...r,
                                inputValue: r.inputValue ?? '',
                                // Use empty string for zero so UI can show placeholder "0"
                                paymentAllocationStr: r.paymentAllocationStr ?? (pa === 0 ? '' : pa.toString()),
                                paymentAllocation: pa
                            };
                        }).map((monthLine, i) =>
                            <MonthLine
                                monthLine={monthLine}
                                key={`${monthLine.tenant.id}-${i}`}
                                ref={ref => (childRefs.current[i] = ref)}
                                index={i}
                                handlePaymentAllocation={handlePaymentAllocation}
                                saveMonthLine={handleLocalSaveMonthLine}
                                showSettled={includeSettled}
                            />
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};